import { ReactElement } from "react";
import { LAYOUT_GROUPING_GROUP } from "../../../../../constants/routes";
import { useParamAsNumber } from "../../../../../hooks/useParamAsNumber";
import { StorefrontLayoutGroupDetail } from "./StorefrontLayoutGroupDetail";
import { StorefrontLayoutOverview } from "./StorefrontLayoutOverview";

export const StorefrontLayout = (): ReactElement => {
  const selectedGroupId = useParamAsNumber(
    LAYOUT_GROUPING_GROUP,
    "groupId",
    false,
  );

  if (selectedGroupId) {
    return <StorefrontLayoutGroupDetail groupId={selectedGroupId} />;
  }

  return <StorefrontLayoutOverview />;
};
